/* sp-header-search.js — bespoke predictive search for Stock Padel header.
 * Native-grade: wired to Shopify Predictive Search API (/search/suggest.json).
 * Hooks: [data-sp-search] root (owner), [data-sp-search-input], [data-sp-search-panel].
 * Anti-race: querySelectorAll + per-node guard (Regla 15). Idempotent on shopify:section:load.
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sp-search]';
  var DEBOUNCE = 180;

  function moneyFromCents(cents, fmt) {
    // Shopify suggest returns price as a string already-formatted via "fields=...".
    // We request the formatted price field; fallback to raw.
    return cents;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPopular(root) {
    var raw = root.getAttribute('data-popular') || '';
    var terms = raw.split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!terms.length) return '';
    var label = root.getAttribute('data-label-popular') || 'Búsquedas populares';
    var html = '<div class="sp-search__group" data-sp-group="popular">';
    html += '<p class="sp-search__group-title">' + esc(label) + '</p>';
    html += '<ul class="sp-search__popular">';
    terms.forEach(function (t) {
      var url = root.getAttribute('data-search-url') + '?q=' + encodeURIComponent(t);
      html += '<li><a class="sp-search__popular-item" href="' + esc(url) + '">' + esc(t) + '</a></li>';
    });
    html += '</ul></div>';
    return html;
  }

  function renderResults(root, data, query) {
    var showCats = root.getAttribute('data-show-categories') === 'true';
    var maxProducts = parseInt(root.getAttribute('data-max-products'), 10) || 4;
    var searchUrl = root.getAttribute('data-search-url');
    var out = '';

    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    if (showCats && collections.length) {
      var labelCat = root.getAttribute('data-label-categories') || 'Categorías';
      out += '<div class="sp-search__group" data-sp-group="categories">';
      out += '<p class="sp-search__group-title">' + esc(labelCat) + '</p>';
      out += '<div class="sp-search__chips">';
      collections.slice(0, 6).forEach(function (c) {
        out += '<a class="sp-search__chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
      });
      out += '</div></div>';
    }

    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var labelProd = root.getAttribute('data-label-products') || 'Productos';
    if (products.length) {
      out += '<div class="sp-search__group" data-sp-group="products">';
      out += '<p class="sp-search__group-title">' + esc(labelProd) + '</p>';
      out += '<ul class="sp-search__products">';
      products.slice(0, maxProducts).forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = p.price || '';
        out += '<li><a class="sp-search__product" href="' + esc(p.url) + '">';
        out += '<span class="sp-search__product-thumb">';
        if (img) out += '<img src="' + esc(img) + '" alt="" loading="lazy" width="40" height="40">';
        out += '</span>';
        out += '<span class="sp-search__product-info">';
        out += '<span class="sp-search__product-name">' + esc(p.title) + '</span>';
        if (price) out += '<span class="sp-search__product-price">' + esc(price) + '</span>';
        out += '</span></a></li>';
      });
      out += '</ul></div>';
    }

    if (!out) {
      var empty = root.getAttribute('data-label-empty') || 'Sin resultados para';
      out = '<div class="sp-search__group"><p class="sp-search__empty">' + esc(empty) + ' “' + esc(query) + '”</p></div>';
    }
    var seeAll = root.getAttribute('data-label-seeall') || 'Ver todos los resultados';
    out += '<a class="sp-search__seeall" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(query) + '">' + esc(seeAll) + ' →</a>';
    return out;
  }

  function openPanel(root) {
    var panel = root.querySelector('[data-sp-search-panel]');
    if (!panel) return;
    panel.hidden = false;
    root.setAttribute('data-sp-open', '1');
  }

  function closePanel(root) {
    var panel = root.querySelector('[data-sp-search-panel]');
    if (!panel) return;
    panel.hidden = true;
    root.removeAttribute('data-sp-open');
  }

  function fetchSuggest(root, query) {
    var maxProducts = parseInt(root.getAttribute('data-max-products'), 10) || 4;
    var showCats = root.getAttribute('data-show-categories') === 'true';
    var types = showCats ? 'product,collection' : 'product';
    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') +
      'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=' + types +
      '&resources[limit]=' + Math.max(maxProducts, 6) +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function initRoot(root) {
    if (root.dataset.spBound === '1') return;
    root.dataset.spBound = '1';

    var input = root.querySelector('[data-sp-search-input]');
    var panel = root.querySelector('[data-sp-search-panel]');
    if (!input || !panel) return;

    var popularHTML = buildPopular(root);
    var timer = null;
    var lastQuery = '';

    function showPopular() {
      panel.innerHTML = popularHTML;
      if (popularHTML) openPanel(root); else closePanel(root);
    }

    function onInput() {
      var q = input.value.trim();
      lastQuery = q;
      window.clearTimeout(timer);
      if (q.length < 2) {
        showPopular();
        return;
      }
      timer = window.setTimeout(function () {
        fetchSuggest(root, q).then(function (data) {
          if (input.value.trim() !== q) return; // stale
          panel.innerHTML = renderResults(root, data, q);
          openPanel(root);
        }).catch(function () {
          panel.innerHTML = renderResults(root, { resources: { results: {} } }, q);
          openPanel(root);
        });
      }, DEBOUNCE);
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length < 2) showPopular(); else onInput();
    });

    // Cierre: ESC
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(root); input.blur(); }
    });

    // Cierre: click fuera
    if (!document._spSearchOutsideBound) {
      document._spSearchOutsideBound = true;
      document.addEventListener('click', function (e) {
        document.querySelectorAll(ROOT_SEL).forEach(function (r) {
          if (!r.contains(e.target)) {
            var p = r.querySelector('[data-sp-search-panel]');
            if (p) { p.hidden = true; r.removeAttribute('data-sp-open'); }
          }
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
